import React, { useCallback, useState, useEffect, useRef } from "react"
import { useHistory } from "react-router-dom"
import Form from "@bappweb/form"
import Panel from "@bappweb/panel"
import TextField from "@bappweb/textfield"
import Button from "@bappweb/button"
import Checkbox from "@bappweb/checkbox"
import Link from "@bappweb/link"
import Captcha from "@smpu-web/nested/form/captcha"
import FormMessage from "@smpu-web/globalmodules/form-message/index"
import Page from "@smpu-web/globalmodules/page"
import Element from "@bappweb/element"
import { numeric, RegexpTypes, required, dateFormat } from "@bappweb/utils"
import { useGetTokenByTckn1Mutation, useGetCaptchaMutation, useRefreshCaptchaMutation, useApplyMutation } from "../../../api/services"
import { useAppDispatch } from "src/projects/kobi-isbirlikleri/config/hook"
import "../assets/style.scss"
import "../../../../../assets/styles/style.scss"
import RadioGroup from "@bappweb/radiogroup"
import Radio from "@bappweb/radio"
import { setSessionData } from "../../../state/sessionData"


function MainForm() {
  const history = useHistory()
  const dispatch = useAppDispatch()

  const [identityNumber, setIdentityNumber] = useState('')
  const [captchaValues, setCaptchaValues] = useState({
    tokenSessionId: "",
    captchaData: "",
    captcha: "",
    showCaptcha: false,
    captchaValidate: true
  })

  const [error, setError] = useState<string>()
  const [isFetching, setIsFetching] = useState(false)
  const [radioType, setRadioType] = useState("1")
  const [vknNumber, setVknNumber] = useState("")
  const [mbbNumber, setMbbNumber] = useState("")
  const refForm = useRef(null)

  const [getCaptcha] = useGetCaptchaMutation();

  useEffect(() => {

    // @ts-ignore TODO
    // Captcha alanı temizlendiğinde validasyon hatası alıyor. O nedenle bu şekilde alanı temizliyoruz.
    refForm.current?.setValue("captcha", "")
    setCaptchaValues({
      ...captchaValues,
      tokenSessionId: "",
      showCaptcha: false,
      captchaData: "",
      captcha: "",
      captchaValidate: true
    })
  }, [radioType])

  useEffect(() => {
    if (captchaValues.captchaData === "" && captchaValues.tokenSessionId !== "") {
      setIsFetching(true)
      getCaptcha({
        tcknVknMbbNo: radioType == "1" ? identityNumber : radioType == "2" ? vknNumber : mbbNumber,
        accessType: radioType == "1" ? "tckn" : radioType == "2" ? "vkn" : "mbb",
        TokenSessionId: captchaValues.tokenSessionId
      })
        .unwrap()
        .then((payload) => {
          if (!payload.IsError) {
            setError('')
            setCaptchaValues({
              ...captchaValues,
              showCaptcha: true,
              captchaData: payload.captchaData,
              captchaValidate: true
            })
          }
          else {
            setError(payload.ErrorMessage ? payload.ErrorMessage : "")
          }
        })
        .finally(() => { setIsFetching(false) })
    }
  }, [captchaValues, getCaptcha, identityNumber, vknNumber, mbbNumber])

  const handleRadioTypeChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target
    if (value === "1") {
      setRadioType("1")
    }
    else if (value === "2") {
      setRadioType("2")
    } else {
      setRadioType("3")
    }
  }, [])

  const [getTokenByTckn1] = useGetTokenByTckn1Mutation();

  const handleChange = useCallback((e) => {
    const name = e.target.name
    const value = e.target.value

    switch (name) {
      case "identityNumber":
        setIdentityNumber(value)
        setCaptchaValues({
          ...captchaValues,
          tokenSessionId: "",
          showCaptcha: false,
          captchaData: ""
        })
        if (value.length === 11) {
          setIsFetching(true)
          getTokenByTckn1(value)
            .unwrap()
            .then((payload) => {
              if (!payload.IsError) {
                setError('')
                setCaptchaValues({
                  ...captchaValues,
                  tokenSessionId: payload.tokenSessionId,
                })
              } else {
                setError(payload.ErrorMessage ? payload.ErrorMessage : "")
              }
            })
            .finally(() => { setIsFetching(false) })
        }
        break;
      case "vknNumber":
        setVknNumber(value)
        setCaptchaValues({
          ...captchaValues,
          tokenSessionId: "",
          showCaptcha: false,
          captchaData: ""
        })
        if (value.length === 10) {
          setIsFetching(true)
          getTokenByTckn1(value)
            .unwrap()
            .then((payload) => {
              if (!payload.IsError) {
                setError('')
                setCaptchaValues({
                  ...captchaValues,
                  tokenSessionId: payload.tokenSessionId,
                })
              } else {
                setError(payload.ErrorMessage ? payload.ErrorMessage : "")
              }
            })
            .finally(() => { setIsFetching(false) })
        }
        break;
      case "mbbNumber":
        setMbbNumber(value)
        setCaptchaValues({
          ...captchaValues,
          tokenSessionId: "",
          showCaptcha: false,
          captchaData: ""
        })
        if (value.length === 8) {
          setIsFetching(true)
          getTokenByTckn1(value)
            .unwrap()
            .then((payload) => {
              if (!payload.IsError) {
                setError('')
                setCaptchaValues({
                  ...captchaValues,
                  tokenSessionId: payload.tokenSessionId,
                })
              } else {
                setError(payload.ErrorMessage ? payload.ErrorMessage : "")
              }
            })
            .finally(() => { setIsFetching(false) })
        }
        break;
      case "captcha":
        setCaptchaValues({
          ...captchaValues,
          captcha: value,
          captchaValidate: true
        })
        break;
      default:
        break;
    }
  }, [getTokenByTckn1, captchaValues])

  const [refreshCaptcha] = useRefreshCaptchaMutation();
  const handleCaptchaRefresh = useCallback(() => {
    setIsFetching(true)
    refreshCaptcha({
      tcknVknMbbNo: radioType == "1" ? identityNumber : radioType == "2" ? vknNumber : mbbNumber,
      accessType: radioType === "1" ? "tckn" : radioType === "2" ? "vkn" : "mbb",
      TokenSessionId: captchaValues.tokenSessionId,
    })
      .unwrap()
      .then((payload) => {
        if (!payload.IsError) {
          setError('')
          setCaptchaValues({
            ...captchaValues,
            captchaData: payload.captchaData,
            captchaValidate: true
          })
        } else {
          setError(payload.ErrorMessage ? payload.ErrorMessage : "")
        }
      })
      .finally(() => { setIsFetching(false) })
  }, [refreshCaptcha, identityNumber, vknNumber, mbbNumber, captchaValues])

  const [apply] = useApplyMutation()

  const handleSubmit = useCallback(
    (e?: React.BaseSyntheticEvent, values?: Record<string, any>) => {
      if (values && values.captcha) {
        setIsFetching(true)
        apply({
          tcknVknMbbNo: radioType === "1" ? values.identityNumber : radioType === "2" ? values.vknNumber : values.mbbNumber,
          erisimTipi: radioType === "1" ? "tckn" : radioType === "2" ? "vkn" : "mbb",
          captcha: values.captcha.toUpperCase(),
          kvkk: values.checkboxKvkk,
          NextTransactionUrl: "Facebook/DisTicaretDanismanlik/Apply1",
          TokenSessionId: captchaValues.tokenSessionId,
        })
          .unwrap()
          .then((payload) => {
            if (!payload.IsError && !payload.inviteToBranch) {
              setError('')
              dispatch(
                setSessionData({
                  musteriTipi: payload.musteriTipi,
                  erisimTipi: radioType === "1" ? "tckn" : radioType === "2" ? "vkn" : "mbb",
                })
              )
              history.push({
                pathname: "/details/info",
                state: payload
              })
            } else {
              setError(payload.ErrorMessage ? payload.ErrorMessage : "")
              window.scrollTo({
                top: 0,
              });
              refreshCaptcha({
                tcknVknMbbNo: radioType === "1" ? values.identityNumber : radioType === "2" ? values.vknNumber : values.mbbNumber,
                accessType: radioType === "1" ? "tckn" : radioType === "2" ? "vkn" : "mbb",
                TokenSessionId: captchaValues.tokenSessionId
              })
                .unwrap()
                .then((payload) => {
                  if (!payload.IsError) {
                    setCaptchaValues({
                      ...captchaValues,
                      captcha: "",
                      showCaptcha: true,
                      captchaData: payload.captchaData,
                      captchaValidate: false
                    })
                  }
                  else {
                    setError(payload.ErrorMessage ? payload.ErrorMessage : "")
                  }
                })
                .finally(() => { setIsFetching(false) })
            }
          })
          .finally(() => { setIsFetching(false) })
      }
    },
    [history, apply, captchaValues, identityNumber, vknNumber, mbbNumber, refreshCaptcha]
  )

  return (
    <Page>
      <Form onSubmit={handleSubmit} onChange={handleChange} grid={false}>
        <Panel hasFooter connected={false}>
          <FormMessage className={"form-msg-error"} error={error}></FormMessage>
          <Panel.Body>
            <Element type="h1" className="bapp-panel-body-card-description">
              Dış Ticaret Destek Hizmetinden faydalanabilmek ve konuyla ilgili sorunuzu yöneltmek için aşağıdaki
              bilgilerden herhangi birini giriniz.
            </Element>
            <RadioGroup
              value={radioType}
              name="radioType"
              onChange={handleRadioTypeChange}
              block={false}>
              <Radio className="radioOne" label="TC Kimlik Numaranız" name="radioType" value="1" />
              <Radio label="Vergi Kimlik Numaranız" name="radioType" value="2" />
              <Radio label="Müşteri Numaranız" name="radioType" value="3" />
            </RadioGroup>

            {radioType === "1" ? (<TextField
              label='TC Kimlik No'
              type="text"
              name="identityNumber"
              maxLength={11}
              value={identityNumber}
              validator={RegexpTypes.Numeric}
              validations={[required("TC Kimlik Numarası alanı zorunludur."), numeric()]}
            />) : null}
            {radioType === "2" ? (<TextField
              type="text"
              name="vknNumber"
              label="Vergi Kimlik No"
              maxLength={10}
              value={vknNumber}
              validator={RegexpTypes.Numeric}
              validations={[required("Lütfen VKN Numaranızı giriniz")]}
            />) : null}
            {radioType === "3" ? (<TextField
              type="text"
              name="mbbNumber"
              label="Müşteri Numarası"
              maxLength={10}
              value={vknNumber}
              validator={RegexpTypes.Numeric}
              validations={[required("Lütfen Müşteri Numaranızı giriniz")]}
            />) : null}
            {captchaValues.showCaptcha && (
              <Captcha
                label="Güvenlik Kodu"
                id="captcha"
                type="text"
                name="captcha"
                placeholder="Güvenlik Kodu"
                captcha={captchaValues.captchaData}
                value={captchaValues.captcha}
                captchaValidate={captchaValues.captchaValidate}
                maxLength={4}
                maxRefreshCount={3}
                refreshClick={handleCaptchaRefresh}
                validations={[required("Lütfen güvenlik kodunu giriniz.")]}
              />
            )}
            <Checkbox
              name="checkboxKvkk"
              validations={[required("Lütfen onay kutusunu işaretleyiniz.")]}
              className="cb-position-fix"
              block
            >
              <Link
                href="//www.akbank.com/Documents/KISISELVERILERINKORUNMASI_TR.pdf"
                text={"Kişisel Verilerin Korunması Kanunu"}
                inline
                target="_blank"
              />
              {" hakkında bilgilendirme'yi okudum."}
            </Checkbox>
          </Panel.Body>
          <Panel.Footer>
            <Button text="DEVAM" type="submit" fetching={isFetching} disabled={isFetching}
              onClick={() =>
                setCaptchaValues({
                  ...captchaValues,
                  captchaValidate: true
                })
              } />
          </Panel.Footer>
        </Panel>
      </Form>
      <Element type="p" className="form-information-text">{"**Gerekli durumlarda işleminizin tamamlanabilmesi için Müşteri İletişim Merkezimiz sizinle iletişime geçecektir."}</Element>
    </Page>
  )
}

export default MainForm
